import styled from "styled-components";
import { MainInner } from "@/styles/global";

const FundSingleWrapper = styled(MainInner)`
  max-width: none;
  padding: 0;
  margin-top: 122px;

  @media (max-width: 768px) {
    margin-top: 60px;
  }
`;

const FundSingleWrapperInner = styled(MainInner)`
  margin: 0 auto;
  margin-bottom: 60px;
  padding: 0 24px;
  max-width: 1300px;
`;

const S = {
  FundSingleWrapper,
  FundSingleWrapperInner,
};

export default S;
